import { Factory } from "../../../core/factory";

import { DEFAULT_ANIMATION_CONFIG } from "../../../animation/config";

function LinearProgressGrowOption(params) {
    return () => "vertical" === params.direction ? {
        orient: "negative"
    } : {
        orient: "positive"
    };
}

const Appear_Grow = params => ({
    type: "horizontal" === params.direction ? "growWidthIn" : "growHeightIn",
    options: LinearProgressGrowOption(params)
});

export const linearProgressDisappear = params => ({
    type: "horizontal" === params.direction ? "growWidthOut" : "growHeightOut",
    options: LinearProgressGrowOption(params)
});

export const Appear_FadeIn = {
    type: "fadeIn"
};

export function linearProgressPresetAnimation(params, preset = "grow") {
    return !1 === preset ? {} : "fadeIn" === preset ? Appear_FadeIn : Appear_Grow(params);
}

export const registerLinearProgressAnimation = () => {
    Factory.registerAnimation("linearProgress", ((params, preset) => ({
        appear: linearProgressPresetAnimation(params, preset),
        enter: linearProgressPresetAnimation(params),
        disappear: {
            duration: DEFAULT_ANIMATION_CONFIG.disappear.duration
        }
    })));
};
//# sourceMappingURL=animation.js.map
